import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';


import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs/Observable';
import { Contact } from '../../shared/model/conversationContacts';
import { ConversationContact as ConvContact } from '../../shared/model/conversationContacts';
import {environment} from '../../../../environments/environment';
import * as ServerObj from '../../shared/model/serverObjects';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/interval';


@Injectable()
export class InboxService {
    constructor(private http: Http) { }


      /**
   *  Get Inbox Grid Data
   */
  getInboxData() {
            //this.http.get('mockdata/inboxView')
  console.log('inside getInboxData service');
    return <Observable<ServerObj.RootObject>>
            this.http.get('mockdata/inboxView')
            .map(response => this.extract <ServerObj.RootObject> (response))
            .catch(err => this.handleError(err))
            .finally(() => {
              console.log('environment is ' + environment.envName);
            console.log('Inbox Data finished');
            });

  }

    private extract<T>(res: Response) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    const body = res.json ? res.json() : null;
    return <T>(body && body.data || {});
  }

  private handleError( err: any) {
    return Observable.of(false);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/inbox/shared/inbox.service.ts